<template>
  <div class="dropdown" :class="dropdownToggled ? 'show' : ''">
    <button class="actions-button ml-auto mr-auto" @click="toggleShow">
      <font-awesome-icon icon="pencil-alt" />
    </button>
    <div
      class="dropdown-menu dropdown-menu-custom"
      :class="dropdownToggled ? 'show' : ''"
      :style="dropdownMenuPositionStyles"
      x-placement="top"
    >
      <div class="dropdown-item dropdown-item-custom-styles" @click="goToFileProcessTree">
        Show files tree
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StudiesDropdown',
  props: {
    fileProcessId: Number,
    goToFileProcessDetails: Function
  },
  data () {
    return {
      dropdownToggled: false,
      parent: {}
    }
  },
  computed: {
    dropdownMenuPositionStyles () {
      return {
        'position': 'fixed !important',
        top: (this.parent.top || 0) + 'px !important',
        left: (this.parent.left || 0) - 70 + 'px !important'
      }
    }
  },

  methods: {
    toggleShow (e) {
      this.parent = e.target.getBoundingClientRect()
      this.dropdownToggled = !this.dropdownToggled
    },
    async goToFileProcessTree () {
      await this.goToFileProcessDetails(this.fileProcessId)
    }
  },
  handleCloseDropdown () {
    this.dropdownToggled = false
  }

}
</script>
<style scoped lang="scss">
@import '../../assets/scss/variables';
.actions-button {
  position: relative;
  width: 40px;
  height: 40px;
  margin: 0 auto;
  border-radius: .25rem;
  border: none;
  color: $white;
  background-color: $blue-500;
  text-align: center;
  justify-content: center;
  align-items: center;
  svg {
    font-size: 15px;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
.show {
  display: block !important;
}
.dropdown-item-custom-styles {
  padding: .75rem;
}
.dropdown-menu-custom {
  width: unset !important;
  &:hover {
    cursor: pointer;
  }
}
</style>
